/*
  Product card hover zoom — the same behaviour as the product page image: while the mouse
  is over a card image, the image is magnified with its origin following the cursor.
  One delegated listener covers every card on the page, including ones added later
  (carousels, quick view, filters). Mouse only: touch taps are left alone.
*/
(function () {
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var active = null, raf = null, pending = null;

  function paint() {
    raf = null;
    if (!pending) return;
    pending.el.style.setProperty('--cz-x', pending.x + '%');
    pending.el.style.setProperty('--cz-y', pending.y + '%');
  }
  function stop() {
    if (!active) return;
    active.classList.remove('is-zooming');
    active = null; pending = null;
  }

  document.addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse' || !fine.matches) return;
    var el = e.target && e.target.closest ? e.target.closest('[data-card-zoom]') : null;
    if (el !== active) stop();
    if (!el) return;
    if (!active) { active = el; el.classList.add('is-zooming'); }
    var r = el.getBoundingClientRect();
    pending = {
      el: el,
      x: Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100)),
      y: Math.max(0, Math.min(100, (e.clientY - r.top) / r.height * 100))
    };
    if (!raf) raf = window.requestAnimationFrame(paint);
  }, { passive: true });

  document.addEventListener('pointerout', function (e) { if (!e.relatedTarget) stop(); });
  window.addEventListener('blur', stop);
})();
